<template>
  <div data-test-id="authContent" class="section">
    <h2 v-if="isDefined(header)">{{ header }}</h2>
    <p class="section-content">
      {{ message }}
    </p>
    <p class="section-content">
      <slot> </slot>
    </p>
    <ButtonPrimary
      v-if="showReload"
      :loading="isReloading"
      :disabled="isReloading || isLoggingOut"
      :text="t('buttons.reload')"
      @click="reload"
    />
    <ButtonAlternate
      :loading="isLoggingOut"
      :disabled="isReloading || isLoggingOut"
      style="margin-left: 0.5rem"
      v-if="forceRefresh"
      :text="t('buttons.logout')"
      @click="logout"
    />
  </div>
</template>

<script setup lang="ts">
// STORES, IMPORTS, & COMPOSABLES
import { isDefined } from '@/composables/utils'
import type { LogoutOptions } from '@auth0/auth0-spa-js'
import { getAuthInstance, getLogoutRedirect } from '@fusion/auth-v3'
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import ButtonAlternate from '../buttons/ButtonAlternate.vue'

const auth0 = getAuthInstance()
const { t } = useI18n({ useScope: 'global' })

// PROPS & EMITS
const props = defineProps({
  header: { type: String, default: '' },
  message: { type: String, default: '' },
  forceRefresh: { type: Boolean, default: false },
  showReload: { type: Boolean, default: true }
})

// REACTIVE VARIABLES
const isReloading = ref(false)
const isLoggingOut = ref(false)

// COMPUTED PROPERTIES

// LIFECYCLE HOOKS

// FUNCTIONS
const logout = async () => {
  isLoggingOut.value = true
  const opts: LogoutOptions = {
    logoutParams: {
      returnTo: getLogoutRedirect(APP_ENV.VITE_APP_PUBLIC_PATH)
    }
  }
  return auth0.logout(opts)
}

const reload = async () => {
  isReloading.value = true
  // Force auth0 to reauthenticate so rules are run again and user roles are updated
  if (props.forceRefresh) {
    await auth0.getTokenSilently({ cacheMode: 'off' })
  }
  window.location.reload()
}
</script>

<style lang="scss" scoped>
.section {
  padding: 1rem 1rem 0rem 1rem;
  max-width: 500px;
}

.section-content {
  margin: 1rem 0 1rem 0;
  padding: 0;
}

.title {
  margin: 0;
  padding: 0;
}
</style>
